import { render, staticRenderFns } from "./partenaire_section.vue?vue&type=template&id=5a2fde86&scoped=true"
import script from "./partenaire_section.vue?vue&type=script&lang=js"
export * from "./partenaire_section.vue?vue&type=script&lang=js"
import style0 from "./partenaire_section.vue?vue&type=style&index=0&id=5a2fde86&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2fde86",
  null
  
)

export default component.exports